import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectRecipes } from "./redux/selectors/selectors";
import SearchForm from "./components/SearchForm/SearchForm";
import { Container, Button, AppBar, Toolbar } from "@mui/material";
import { toggleSearchButton } from "./redux/actions/actions";
import Recipes from "./components/Recipes/Recipes";
import "./App.css";

function App() {
  const recipes = useSelector(selectRecipes);
  const recipesAvailable = recipes.length > 0;
  const showSearchButton = useSelector((state) => state.showSearchButton);
  const dispatch = useDispatch();

  const handleSearchAgain = () => {
    window.location.reload();
  };

  return (
    <div className="app-wrapper">
      <AppBar
        position="fixed"
        style={{ background: "transparent", boxShadow: "none" }}
      >
        <Toolbar sx={{ justifyContent: "center", mt: 2 }}>
          {showSearchButton && (
            <Button
              variant="contained"
              onClick={handleSearchAgain}
              sx={{
                px: 4,
                py: 1.2,
                borderRadius: 3,
                fontWeight: 900,
                letterSpacing: 0.6,
                textTransform: "uppercase",
                color: "black",
                background: "linear-gradient(90deg, #ffb74d, #ffa726)",
                boxShadow: "0 14px 30px rgba(0,0,0,0.35)",
                transition: "transform 160ms ease, box-shadow 160ms ease",
                "&:hover": {
                  background: "linear-gradient(90deg, #ffc266, #ffb74d)",
                  boxShadow: "0 18px 40px rgba(0,0,0,0.5)",
                  transform: "translateY(-2px)",
                },
              }}
            >
              Search Again
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" className="app-container">
        {recipesAvailable ? (
          <Recipes onRecipesRender={() => dispatch(toggleSearchButton())} />
        ) : (
          <SearchForm />
        )}
      </Container>
    </div>
  );
}

export default App;
